
import React from "react";
import {
    Button, FlexColumn, SushiModal,
    WhiteWrapper,
    Wrapper,
} from "../../Common/styles.common";
import { Loader } from "../../Common/Loader";
import { PO_ORDER_TAG_MANDI_DD, PROFILE_INPUT_BORDER } from "utils/constants/others";
import styles from "../../Login/Login.module.scss";
import Input from "sushiweb/InputTypes/Input";
import UploadCard from "../UploadCard";
import ShowToast from "../../Common/Toast";
import DDPoHeader from "../../Header/DDPoHeader";
import PreviewInvoice from "./PreviewInvoice/PreviewInvoice";
import PreviewReuploadedInvoice from "./PreviewInvoice/PreviewReuploadedInvoice";
import moment from "moment";

const DDPoInvoiceFormView = ({
    po,
    items,
    showLoader,
    tonnage,
    showError,
    invoiceDetails,
    errorMsg,
    showToast,
    showPDF,
    pdfBlob,
    setPdfBlob,
    showFile,
    setShowFile,
    showImages,
    setShowImages,
    imageArray,
    setImageArray,
    pngArray,
    setPngArray,
    formData,
    setFormData,
    showPopup,
    setShowPopup,
    useSellerAddress,
    setUseSellerAddress,
    setInvoiceDetails,
    cities,
    meta,
    closePopupHandler,
    setUpdateInvoiceDetails,
    wrapperToNavigateToInvoicePdf,
    pageSource,
    poNumber,
    presignedUrl,
    documentPath,
}) => {
    const pageSourceValue = pageSource || "form";

    return (
        <React.Fragment>
            {showLoader ? (
                <Loader />
            ) : (showPDF && po) ? (
                pageSource === "reuploadInvoice" ?
                    <PreviewReuploadedInvoice
                        poId={po.id}
                        purchaseOrderNumber={po.purchase_order_number}
                        itemsLength={items.length}
                        tonnage={tonnage}
                        pdfBlob={pdfBlob}
                        invoiceDetails={invoiceDetails}
                        setShowFile={setShowFile}
                        formData={formData}
                        params={invoiceDetails}
                        po={po}
                        presignedUrl={presignedUrl}
                        documentPath={documentPath}
                        metadata={meta}
                    /> :
                    <PreviewInvoice
                        poId={po.id}
                        purchaseOrderNumber={po.purchase_order_number}
                        itemsLength={items.length}
                        tonnage={tonnage}
                        pdfBlob={pdfBlob}
                        invoiceDetails={invoiceDetails}
                        setShowFile={setShowFile}
                        formData={formData}
                        params={invoiceDetails}
                        po={po}
                    ></PreviewInvoice>
            ) : po ? (
                <Wrapper>
                    <DDPoHeader
                        poId={po.id}
                        purchaseOrderNumber={po.purchase_order_number}
                        itemsLength={items.length}
                        tonnage={tonnage}
                        source={pageSourceValue}
                    ></DDPoHeader>
                    <div className="d-flex flex-column po-content">
                        {((po.order_tag === "DIRECT_DELIVERY" && po.is_multiple_grn_enabled === true) || (po.order_tag === PO_ORDER_TAG_MANDI_DD && po.is_multiple_grn_enabled === true) && po.ref_order_number != "MERCHANT_BULK") || (pageSource === "reuploadInvoice") ?
                            <WhiteWrapper className="invoice-form ml-2 mr-2 mt-1">
                                <h4>Invoice details</h4>
                                <Input
                                    type="string"
                                    label="Invoice Number"
                                    borderColor={PROFILE_INPUT_BORDER}
                                    value={invoiceDetails.invoice_number}
                                    errorMsg={showError ? errorMsg.invoice_number_error : ""}
                                    className={styles.InputPhoneNumberStyle}
                                    onChange={(value) =>
                                        setUpdateInvoiceDetails(value, "InvoiceNumber")
                                    }
                                />
                                <Input
                                    type="date"
                                    label="Invoice date"
                                    borderColor={PROFILE_INPUT_BORDER}
                                    value={invoiceDetails.invoice_date}
                                    errorMsg={showError ? errorMsg.invoice_date_error : ""}
                                    className={styles.InputPhoneNumberStyle}
                                    onChange={(value) =>
                                        setUpdateInvoiceDetails(value, "InvoiceDate")
                                    }
                                    max={moment(new Date()).toISOString().split('T')[0]}
                                />
                                <Input
                                    type="number"
                                    label="Invoice amount including taxes"
                                    borderColor={PROFILE_INPUT_BORDER}
                                    value={invoiceDetails.invoice_amount}
                                    errorMsg={showError ? errorMsg.invoice_amount_error : ""}
                                    className={styles.InputPhoneNumberStyle}
                                    onChange={(value) =>
                                        setUpdateInvoiceDetails(value, "InvoiceAmount")
                                    }
                                />
                                {po.order_tag === "DIRECT_DELIVERY" && (
                                    <>
                                        <div className="d-flex align-items-center mb-2">
                                            <input
                                                type="checkbox"
                                                id="useSellerAddress"
                                                checked={useSellerAddress}
                                                onChange={(e) => {
                                                    const checked = e.target.checked;
                                                    setUseSellerAddress(checked);
                                                    setInvoiceDetails({
                                                        ...invoiceDetails,
                                                        is_custom_shipping_address_required: !checked,
                                                        shipping_address_line1: checked ? '' : invoiceDetails.shipping_address_line1,
                                                        shipping_city: checked ? '' : invoiceDetails.shipping_city,
                                                        shipping_pincode: checked ? '' : invoiceDetails.shipping_pincode,
                                                    });
                                                }}
                                                style={{ width: '16px', height: '16px', cursor: 'pointer', marginRight: '8px' }}
                                            />
                                            <label htmlFor="useSellerAddress" className="fs-13 fw-500 mb-0 ml-1" style={{ cursor: 'pointer', lineHeight: 'normal', color: '#a9a9a9' }}>
                                                Use Seller address as shipping address
                                            </label>
                                        </div>
                                        {!useSellerAddress && (
                                            <>
                                                <Input
                                                    type="string"
                                                    label="Shipping address Line 1"
                                                    borderColor={PROFILE_INPUT_BORDER}
                                                    value={invoiceDetails.shipping_address_line1 || ''}
                                                    className={styles.InputPhoneNumberStyle}
                                                    style={{ marginTop: '1rem' }}
                                                    onChange={(value) =>
                                                        setUpdateInvoiceDetails(value, "ShippingLine1")
                                                    }
                                                />
                                                <div>
                                                    <label className="fs-11 fw-400 mb-2" style={{ display: 'block', color: '#a9a9a9', fontSize: '15px' }}>Shipping address City</label>
                                                    <select
                                                        value={invoiceDetails.shipping_city || ''}
                                                        onChange={(e) => setUpdateInvoiceDetails(e.target.value, "ShippingCity")}
                                                        style={{
                                                            width: '100%',
                                                            padding: '10px 12px',
                                                            border: `1px solid ${PROFILE_INPUT_BORDER}`,
                                                            borderRadius: '8px',
                                                            fontSize: '18px',
                                                            backgroundColor: '#fff',
                                                            color: '#a9a9a9',
                                                            appearance: 'auto',
                                                            cursor: 'pointer',
                                                            marginBottom: '2.5rem',
                                                        }}
                                                    >
                                                        <option value="">Select city</option>
                                                        {cities.map((city) => (
                                                            <option key={city.id} value={city.city_name}>{city.city_name}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <Input
                                                    type="number"
                                                    label="Shipping address Pincode"
                                                    borderColor={PROFILE_INPUT_BORDER}
                                                    value={invoiceDetails.shipping_pincode || ''}
                                                    className={styles.InputPhoneNumberStyle}
                                                    style={{ marginBottom: '0' }}
                                                    onChange={(value) =>
                                                        setUpdateInvoiceDetails(value, "ShippingPincode")
                                                    }
                                                />
                                            </>
                                        )}
                                    </>
                                )}
                            </WhiteWrapper>
                            : <></>}
                        <WhiteWrapper className="mt-2 invoice-form ml-2 mr-2">
                            <h4>Upload invoice</h4>
                            <span className="fs-9 fw-400 text-gray-cool">(supported file types for images are .jpeg, .jpg, .png and .tiff)</span>
                            <span className="fs-9 fw-400 text-gray-cool mt-1 mb-2">(supported file types for document is .pdf)</span>
                            <UploadCard
                                showFile={showFile}
                                setShowFile={setShowFile}
                                setUpdateInvoiceDetails={setUpdateInvoiceDetails}
                                showImages={showImages}
                                setShowImages={setShowImages}
                                imageArray={imageArray}
                                setImageArray={setImageArray}
                                pngArray={pngArray}
                                setPngArray={setPngArray}
                                setPdfBlob={setPdfBlob}
                                setFormData={setFormData}
                                setShowPopup={setShowPopup}
                            ></UploadCard>
                        </WhiteWrapper>
                    </div>
                    <WhiteWrapper className="po-bottom">
                        <Button
                            className="fs-13 text-white fw-600"
                            onClick={() => wrapperToNavigateToInvoicePdf(invoiceDetails)}
                        >
                            Continue
                        </Button>
                    </WhiteWrapper>
                    <SushiModal visible={showPopup} isCentered>
                        <FlexColumn className="align-items-center p-5">
                            <span className="fs-22 fw-700 my-4">Please upload only supported file types</span>
                            <span
                                className="fs-14 fw-500 text-red-500"
                                onClick={closePopupHandler}
                            >{" "}
                                Okay
                            </span>
                        </FlexColumn>
                    </SushiModal>
                </Wrapper>
            ) : <></>}
            {showToast ?
                <ShowToast
                    errorMsg={errorMsg.invoice_image_error}
                />
                :
                <></>
            }
        </React.Fragment>
    );
};

export default DDPoInvoiceFormView;
